import styled from 'styled-components';

export const Img = styled('img')`
  object-fit: cover;
  width: 100%;
  height: 100;
`;
